import {
  Box,
  Divider,
  FlexBox,
  IconButton,
  Text,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { PropsWithChildren } from 'lib-shared-types-utils';
import { ReactNode, useCallback } from 'react';

import { CopilotDropdownHeaderFeedback } from './components/feedback';
import styles from './copilotDropdownHeader.module.scss';

type CopilotDropdownHeaderProps = PropsWithChildren & {
  /** Title displayed in the header */
  title: string | ReactNode;
  /** Callback for when the back button is clicked */
  onBack?: () => void;
  /** When true, the divider below the header will not be rendered */
  hideDivider?: boolean;
  /**
   * When a feedbackId is given as either a string or null, the feedback buttons
   * will be rendered. If left undefined feedback buttons will not be rendered.
   */
  feedbackId?: string | null;
  /** Additional arbitrary feedback */
  additionalFeedback?: Record<string, string | null>;
  /** Content rendered left of the feedback buttons */
  actions?: ReactNode;
};

export const CopilotDropdownHeader = ({
  children,
  title,
  onBack,
  hideDivider,
  feedbackId,
  additionalFeedback,
  actions,
}: CopilotDropdownHeaderProps): JSX.Element => {
  const showBack = onBack !== undefined;
  const handleOnBack = useCallback(() => {
    ampli.agentCopilotBackButtonClicked();
    onBack?.();
  }, [onBack]);
  return (
    <Box>
      <FlexBox gap="300" padding="250">
        <FlexBox gap="200" flex="0 1 100px" alignItems="center">
          {showBack && (
            <IconButton
              variant="tertiary"
              icon="angle-left"
              onClick={handleOnBack}
            />
          )}
          <Text.Heading variant="heading-3" className={styles.header}>
            {title}
          </Text.Heading>
        </FlexBox>

        <Box flex="1">{children}</Box>

        <FlexBox gap="8px" alignItems="center">
          {actions}

          <CopilotDropdownHeaderFeedback
            feedbackId={feedbackId}
            additionalFeedback={additionalFeedback}
          />
        </FlexBox>
      </FlexBox>

      {!hideDivider && <Divider />}
    </Box>
  );
};
